import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BudgetService } from '../../../../../services/budget.service';
import { BudgetCategory } from '../../../../../models/budget-category.model';
import { Location } from '@angular/common';
import { ModalExcluirComponent } from '../../../components/modal-excluir/modal-excluir.component';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { ErrorMessagesService } from 'src/app/shared/messages/services/error-messages.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ItemGrupoOrdemDto } from '../../../../../models/item-grupo-ordem.dto';

@Component({
  selector: 'app-budget-parameter',
  templateUrl: './budget-parameter.component.html',
  styleUrl: './budget-parameter.component.scss'
})
export class BudgetParameterComponent implements OnInit {
  @ViewChild(ModalExcluirComponent) modalExcluir!: ModalExcluirComponent;

  groups: BudgetCategory[] = [];
  private groupSubscriptiopn: Subscription = new Subscription();
  breadCrumbItems!: Array<{}>;
  Yes: string = "Sim";
  uncheckedLabel: any;

  error = "";
  erro403 = false;

  // permissoes
  podeEditar = false;

  modoEdicaoInput = false;

  constructor(
    private toastService: ToastService,
    private location: Location,
    private router: Router,
    public budgetService: BudgetService,
    private errorMessagesService: ErrorMessagesService,
    private authService: AuthService) { }


  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Configurações" },
      { label: "Parâmetros Orçamento", active: true }
    ];

    this.permissaoAdicionarUsuario();

    this.groupSubscriptiopn = this.budgetService.getGroups().subscribe({
      next: (response) => {
        //this.groups = response;
        this.groups = response
        // response.map((group) => ({
        //   ...group, // Garante que orden seja um número
        //   tipoDeCalculo: group.tipoDeCalculo,
        //   tipoDeApresentacao: group.tipoDeApresentacao,
        //   apresentacaoEmOrcamento: group.apresentarEmOrcamento,
        //   tipoDeDespesa: group.tipoDeDespesa
        // }))
      },
      error: (error) => {
        if (error.status == 403) {
          this.erro403 = true;
          return;
        }

        this.error = this.errorMessagesService.getMessage('ERR_0012');
      },
    });
  }

  // Redirecionar para registrar novo Grupo de Orçamento
  registerNewBudgetParameter() {
    this.router.navigate(['/telemarketing/projetos/configuracoes/parametros-orcamento/novo']);
  }

  voltar() {
    this.location.back();
  }

  openModalDelete(budget: BudgetCategory) {

    this.modalExcluir.payload = { budget };
    this.modalExcluir.openModal();
  }

  // Recebe o evento de exclusão do modal
  handleDelete(event: any): void {

    const id = event['budget'].id;

    this.budgetService.deleteCategory(id).subscribe({
      next: (response) => {
        this.groups = this.groups.filter((group) => group.id !== event.documentName);

        this.toastService.show("Excluído com sucesso!", {
          classname: "bg-success text-light",
        });

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      },
      error: (error) => {

        this.error = this.errorMessagesService.getMessage('ERR_0013');

        this.toastService.show("Erro ao tentar excluir categoria!", {
          classname: "bg-danger text-light",
        });
      },
    });
  }

  permissaoAdicionarUsuario(): void {
    this.podeEditar = this.authService.verificarPermissao('Doc_Configuracoes', 'Editar')
  }


  habilitarEdicao(): void {
    this.modoEdicaoInput = true;
  }

  cancelarEdicaoOrdem(): void {
    this.modoEdicaoInput = false;
  }

  salvarOrdem(): void {
    // Monta a lista com os dados essenciais para envio
    const listaParaEnviar: ItemGrupoOrdemDto[] = this.groups.map(row => ({
      id: row.id,
      ordem: row.ordem
    }));

    console.log('Lista para enviar:', listaParaEnviar);

    this.budgetService.atualizarOrdem(listaParaEnviar).subscribe({
      next: () => {
        this.modoEdicaoInput = false;
        this.toastService.show("Ordem atualizada com sucesso!", {
            classname: "bg-success text-light",
          });
        setTimeout(()=>{
          window.location.reload();
        }, 2000)
      },
      error: (err) => {
        console.error('Erro ao salvar a ordem:', err);
        this.toastService.show('Erro ao salvar a ordem.'),
        {
          classname: "bg-danger text-light",
        };
      }
    });

  }
}
